var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRibbon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.288,
    height: 65.282,
    viewBox: "0 0 56.288 65.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ribbon",
    transform: "translate(-3.482 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M27.109,39.173a18.452,18.452,0,0,0,18.6-18.617A18.731,18.731,0,0,0,27.42,2.25a18.452,18.452,0,0,0-18.6,18.617A18.731,18.731,0,0,0,27.109,39.173Zm-.523-28.829a10.39,10.39,0,1,1-9.676,9.69A10.391,10.391,0,0,1,26.587,10.344Z",
    transform: "translate(4.354 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M31.619,25.112a20.956,20.956,0,0,1-15.326-6.639.586.586,0,0,0-.932.1L4.654,37.316a1.162,1.162,0,0,0,1.017,1.737H16.985a1.167,1.167,0,0,1,1,.565L23.5,48.786a1.17,1.17,0,0,0,2.062-.113L31.633,35.31l4.421-9.732a.576.576,0,0,0-.636-.805A22.49,22.49,0,0,1,31.619,25.112Z",
    transform: "translate(0 16.18)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M32.707,18.465a20.988,20.988,0,0,1-7.416,5.1.536.536,0,0,0-.311.3l-6.314,13.8a.571.571,0,0,0,0,.48l4.788,10.523a1.169,1.169,0,0,0,2.062.113l5.509-9.167a1.167,1.167,0,0,1,1-.565H43.343a1.167,1.167,0,0,0,1.017-1.737L33.653,18.549A.617.617,0,0,0,32.707,18.465Z",
    transform: "translate(14.238 16.174)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbon);
export default __webpack_public_path__ + "static/media/ribbon.46369a545bbc5dbb970ec87c16ec7a87.svg";
export { ForwardRef as ReactComponent };